/**
 * The canonical model names.
 */
export enum FanucModel {
  CRX10IA_LP = 'CRX10IA_LP',
}
